export const SIMILAR_CONTENT = 'SIMILAR_CONTENT';
export const RELATED_TOPICS = 'RELATED_TOPICS';
export const LINKED_CONTENTS = 'LINKED_CONTENTS';
export const RECOMMENDED_CONTENTS = 'RECOMMENDED_CONTENTS';
export const SPECIALITY_LIST = 'SPECIALITY_LIST';
export const FILTERED_LIST = 'FILTERED_LIST';
export const FILTERED_LIST_CME = 'FILTERED_LIST_CME';
export const FRESH_CONTENT = 'FRESH_CONTENT';
